export const PERMISSIONS = {
  LIST: 'LIST',
  INSERT:'INSERT',
  EDIT:'EDIT',
  DELETE:'DELETE',
  EXPORT:'EXPORT'
}